import { combineReducers, configureStore } from '@reduxjs/toolkit';
import { persistReducer, persistStore } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import adminAuthReducer from '@store/slices/adminAuthSlice';
import { adminApi } from '@store/api/adminApi';
import { injectStore } from '@api/api';
import dashboardAccessReducer from '@pages/dashboard/dashboardAccessSlice';

const persistConfig = {
  key: 'bundle-drop-admin',
  storage,
  whitelist: ['adminAuth'],
};

const rootReducer = combineReducers({
  adminAuth: adminAuthReducer,
  dashboardAccess: dashboardAccessReducer,
  [adminApi.reducerPath]: adminApi.reducer,
});

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: getDefaultMiddleware =>
    getDefaultMiddleware({
      serializableCheck: false,
    }).concat(adminApi.middleware),
});

injectStore(store);

export const persistor = persistStore(store);

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
